// extracted by mini-css-extract-plugin
export default {"aside-controller":"AsideLeftControllerIcon_aside-controller__ScwGo","icon":"AsideLeftControllerIcon_icon__Zfpta","icon--selected":"AsideLeftControllerIcon_icon--selected__q+mZ5"};